import { useEffect, useRef } from 'react';

/**
 * Hook for checking if the component is being rendered for the first time
 */
const useInitialRender = () => {
    const ref = useRef(true);
    useEffect(() => {
        ref.current = false;
    }, []);
    return ref.current;
};

export default useInitialRender;
